import Pricing from 'components/pricing';
import Main from '../../layouts/main';
import { useSelector } from 'react-redux';
import Dashboard from '../../layouts/dashboard';

function Page() {
  const isLoggedIn = useSelector((s) => s.isLoggedIn);

  return (
    <>
      {isLoggedIn ? (
        <Dashboard>
          <Pricing />
        </Dashboard>
      ) : (
        <Main>
          <Pricing />
        </Main>
      )}
    </>
  );
}

export default Page;
